import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { useAccountStore } from '@/stores/account';
import { useProgramsStore } from '@/stores/programs';
import { useSupervisorStore } from '@/stores/supervisor';
import { computed, onMounted } from 'vue';
import dayjs from 'dayjs';
import VStub from './VStub.vue';
import VUserInfo from './VUserInfo.vue'
import VTableH from './VTableH.vue'
import { useDialogStore } from '@/stores/dialogs';
import CreateSupervisorReportDialog from './dialogs/CreateSupervisorReportDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupervisingTable',
  props: {
    supervisorId: null,
    teamId: null,
    programId: null,
    trackerId: null
  },
  setup(__props: any) {

const props = __props as { supervisorId?: string, teamId?: string | null, programId?: string, trackerId?: string }

const programStore = useProgramsStore()
const accountStore = useAccountStore()
const supervisorStore = useSupervisorStore()



onMounted(() => {
  supervisorStore.requestReports()
})

const data = computed(() => {
  let arr = supervisorStore.reports
  if (!accountStore.isDirector && accountStore.isSupervisor) {
    arr = arr.filter(item => item.supervisorId === accountStore.currentUser?.id)
  }
  if (props.supervisorId && props.supervisorId !== 'all') {
    arr = arr.filter(item => item.supervisorId === props.supervisorId)
  }
  if (props.teamId && props.teamId !== 'all') {
    arr = arr.filter(item => item.teamId === props.teamId)
  }
  if (props.programId) {
    arr = arr.filter(item => item.programId === props.programId)
  }
  if (props.trackerId && props.trackerId !== "all") {
    arr = arr.filter(item => item.trackerId === props.trackerId)
  }
  return arr
})

const rows = {
  date: { title: "", map: (_: any, date: string) => dayjs(date).format("DD.MM.YY"), class: "td-header" },
  supervisorId: { title: "Супервайзер", class: "td-medium" },
  programId: { title: "Программа", class: "td-medium", map: (_: any, programId: any) => programStore.programs.find(program => program.id === programId)?.name },
  teamId: { title: "Команда", class: "td-medium", map: (_: any, teamId: any) => programStore.teams.find(team => team.id === teamId)?.name  },
  trackerId: { title: "Трекер", class: "td-medium" },
  "Оценка за цель команды": { title: "Цель команды", fields: true, class: "td-medium", fallback: "-" },
  "Оценка за цель команды: рекомендации": { title: "Рекомендации", fields: true },
  "Оценка понимания трекером ключевого ограничения": { title: "Ключевое ограничение", fields: true, class: "td-medium", fallback: "-" },
  "Оценка понимания трекером ключевого ограничения: рекомендации": { title: "Рекомендации", fields: true },
  "Есть ли у трекера стратегия работы с командой?": { title: "Стратегия работы", fields: true, class: "td-medium", fallback: "-" },
  "Есть ли у трекера стратегия работы с командой?: Рекомендации": { title: "Рекомендации", fields: true },
}

const dialogStore = useDialogStore()
const editReport = (report: any) => {
  dialogStore.open(CreateSupervisorReportDialog, { report })
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_unref(data).length > 0)
    ? (_openBlock(), _createBlock(VTableH, {
        key: 0,
        rows: rows,
        data: _unref(data)
      }, {
        date: _withCtx(({ cell, item }) => [
          _createTextVNode(_toDisplayString(cell) + " ", 1),
          (item.supervisorId === _unref(accountStore).currentUser?.id)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "edit-button",
                icon: "mdi-pencil",
                size: "x-small",
                variant: "flat",
                onClick: ($event: any) => (editReport(item))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        supervisorId: _withCtx(({ cell }) => [
          _createVNode(VUserInfo, {
            "user-id": cell,
            size: 22
          }, null, 8, ["user-id"])
        ]),
        trackerId: _withCtx(({ cell }) => [
          _createVNode(VUserInfo, {
            "user-id": cell,
            size: 22
          }, null, 8, ["user-id"])
        ]),
        _: 1
      }, 8, ["data"]))
    : (_openBlock(), _createBlock(VStub, { key: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" Отчетов с заданными параметрами не найдено ")
        ]),
        _: 1
      }))
}
}

})